<template lang="pug">
  div(:class="$style.trustPilotWrapper")
    div(:class="$style.trustpilotHead")
      figure
        img(
          src="~/assets/img/trustpilot/brand/brandmark_gr-blk.svg"
          class="fixed-size"
          width="73"
          height="18"
          alt="Trustpilot")
      span {{ trustpilotCustomers }}
    figure(class="mt-0 md:mt-ds-sm")
      img(
        src="~/assets/img/trustpilot/brand/stars-4.5.svg"
        class="fixed-size"
        width="128"
        height="24"
        alt="Trustpilot rating, 4.5 out of 5 stars")

</template>

<script>
import MovingTruck from "@anyvan-ui/icons/svg/truck.svg?url"

export default {
  name: "FormFooterUK",

  props: {
    trustpilotCustomers: {
      type: String,
      default: "0"
    },
    trustpilotRating: {
      type: String,
      default: "0"
    },
  },

  data() {
    return {
      MovingTruck
    }
  }
}
</script>

<style lang="scss" module>
.trustPilotWrapper {
  @apply flex flex-row md:flex-col items-start justify-between md:justify-center mt-ds-md md:mt-0;
  /* Keep the space for content while the TrustPilot API is responding   */
  height: 23px;
  min-width: 135px;
}

.trustpilotHead {
  display: flex;
  width: 125px;
  min-width: 125px;
  margin-right: 10px;

  div {
    width: 60%;

    figcaption {
      display: none;
    }
  }

  span {
    display: block;
    width: 40%;
    text-align: right;
    font-size: 12px;
    font-weight: 600;
    padding-top: 2px;
    padding-left: 5px;
    line-height: 18px;
  }
}

@screen md {
  .trustPilotWrapper {
    height: 62px;
  }
}
</style>
